import { Project } from "types/Project";

const projectData: Project[] = [
	{
		title: "Marketplace",
		type: 'Part-time',
		company: "Montel",
		summary: ["Building a marketplace for both existing and new customer of montel. An user friendly platform where companies within the power industry can sign-up to buy or sell power contracts.", "Delivery impact mostly on the frontend team, and works closesly with the backend team.", "Most of the codebase are build from scratch, where some external libraries and npm packages are taken use of."],

		hashtags: ["#Frontend", "#react", "#typescript", "#.net", "#azure-devops", "#figma", "#restapi ","#swagger"],
		logo: 'images/experience/montel_logo.jpeg',
	},
	{
		title: "NRF | EFO",
		type: 'Part-time',
		company: "Dops",
		summary:["The NRF Database gives the plumber, and EFO gives the electrician workers the opportunity to find relevant products for the job, search for product data, documents, photograph and take notes along the way and then send documentation directly to their customer when the assignment has been completed.", "Both NRF and EFO project use the a common database setup where manufacturers and importers can enter and update product data, and wholesalers have a product database to retrieve product data."],
		hashtags: ["#angular",
					"#typescript",
					"#.net-core",
					"#ASP.NET-MVC",
					"#azure-devops",
					"#bootstrap",
					"#microsoft-sql-server",
					"#entity-framework-core",]
	},
	{
		title: "Chart",
		type: 'Internship',
		company: "Cognite",
		summary: ["Work as a frontend engineer in a product called Charts.",
		"Charts is a powerful tool for engineers and domain experts to explore, trend, and analyze industrial data. It gives industrial experts instant access to data and no-code tools to find, understand and troubleshoot for actionable insights."],
		hashtags: ["#Frontend", "#react", "#typescript", "#firebase", "#jira", "#scrum", "#figma", "#restapi","#asana"],
		logo: 'images/experience/cognite_logo.jpeg',
	},
	{
		title: "Synthetic data",
		type: 'Internship',
		company: "Visma Consulting",
		summary: ["The goal was to create a solution that allows users to easily generate test data that does not compromise on privacy and allows you to test solutions without having to deal with data that contains personal sensitive information. ","The solution consists of three parts, a generator for identities, a backend for generic data generation management, and a front-end application that allows users to view and create people for use in test environments.",

		"Acting as a mentor to others in the team by helping them with their tasks throughout the internship. This includes helping them with code issues as well as knowledge sharing within frontend development. In addition, I also got the responsibility of defining and giving new tasks base on its prority each sprint. Lastly, individual contribution to the codebase itself."],
		hashtags: ["#Frontend", "#react", "#javascript", "#.net", "#azure-devops", "#scrum", "#figma", "#restapi ","#postman"],
		logo: 'images/experience/visma_logo.png',
	},
	{
		title: "Portofolio",
		type: "Personal",
		company: "Private",
		summary: ["Personal project to create a interactive and creative portfolio...."],
		hashtags: [
			"#reactjs",
			"#zeitnow",
			"#vercel",
			"#figma",
			"#javascript",
			"#nodejs",
			"#restapi",
		],
	},
	{
		title: "Muncies",
		type: "Personal",
		company: "Private",
		summary: ["My first project with react as frontend......"],
		hashtags: [
					"#reactjs",
					"#mongodb",
					"#heroku",
					"#figma",
					"#javascript",
					"#nodejs",
					"#restapi",
				],
	}

	
];

export default projectData;